module.exports = __webpack_public_path__ + "static/media/3.21_preview.bc2201aa.png";